import gwt from "../../../../../../../worktime-client/src/main/vue/src/api/gwt";

export default {
    methods: {

        formatCurrency(value) {
            // Verificar si value es nulo o indefinido
            if (value === null || value === undefined) {
              return '';
            }
            // Convertir el valor a una cadena si no es una cadena
            const stringValue = String(value);
          
            // Obtener el locale del empleado
            
            const locale = gwt.getSessionInformation().employee.locale;
          
            // Crear un objeto Intl.NumberFormat para el locale
            const numFormat = new Intl.NumberFormat(locale, {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            });
          
            // Obtener el decimal correcto según el locale
            const decimalSeparator = numFormat.formatToParts(1.1)[1].value;
          
            // Reemplazar el decimal incorrecto con el correcto
            if (decimalSeparator === '.' && stringValue.indexOf(',') !== -1) {
              return stringValue.replace(/,/g, '.');
            } else if (decimalSeparator === ',' && stringValue.indexOf('.') !== -1) {
              return stringValue.replace(/\./g, ',');
            } else {
              return stringValue;
            }
          },

        formatData (vm, rows) {
            for (let row of rows) {
                Object.entries(row).forEach(([key, value]) => {

                    let searchKey = key;
                    let column = vm.headers.find ( h => h.field==searchKey);
                    if (!column) {
                        let searchKey = this.adjustFormatterSearchKey(key);
                        column = vm.headers.find ( h => h.field==searchKey);
                    }
                    if (column && column.formatter)
                    {
                        row[key] = vm[column.formatter](value, column);
                    }
                });
            }
            return rows;
        },
        adjustFormatterSearchKey(key) {
            const regex = /((composite|avatar)[1-9])(_title|_subtitle)/;
            const match = key.match(regex);
            if (match && match.length>1) {
                return match[1];
            }
            return key;
        },
        addCustomData (vm, rows) {
            for (let header of vm.headers) {
                if (header.customValue) {
                    for (let row of rows) {
                        row[header.field] = header.customValue(row);
                    }
                }
            }
            return rows;
        },
        formatBoolean (value) {
            return (typeof value === 'undefined' ) ? '' : 
                    (value ? this.$t('wkt.admin.common.yes').toUpperCase() : this.$t('wkt.admin.common.no').toUpperCase());
        },
        formatDate (value) {
            if (!value) return '';
            return new Date(value).toLocaleDateString([this.$i18n.locale, 'en'], { year: 'numeric', month: '2-digit', day: '2-digit' });
        },
        formatDateTime (value) {
            return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
        },     
        formatDecimalNumber(value) {
            if (value && typeof value === 'number') {
                return (Math.round(value * 100) / 100).toFixed(2).toLocaleString();
            }
            return value;
        },   
        formatDateTimeLocal (value) {
            // muestra la fecha como esta en base de datos (ignora la zona horaria del navegador)
            if (!value) {
                return '';
            }
        
            let dateLocal = new Date(value);
            let timezoneOffset = dateLocal.getTimezoneOffset();
            dateLocal.setTime(dateLocal.getTime() + timezoneOffset * 60 * 1000);

            let dataLocalString = dateLocal.toLocaleDateString() + ' ' + dateLocal.toLocaleTimeString();
            return dataLocalString;
        },
        formatLongDateTime (value) {
                //return this.formatLongDateTime(value, true);
           return !value ? '' : new Date(value).toLocaleDateString() + ' ' + new Date(value).toLocaleTimeString();
        },
        formatSimpleDate (value) {
                //return this.formatLongDate(new Date(value.year, value.month-1, value.day, 0, 0, 0, 0).getTime());
           return !value ? '' : new Date(value.year, value.month-1, value.day, 0, 0, 0, 0).toLocaleDateString();
        },
        formatTime (value) {
            if (!value) return '';
    
            let avalue = Math.abs(value);
    
            let sign = avalue==value ? "":"-";
            
            let hours = Math.floor(avalue);
            let mins = Math.floor((avalue - hours) * 60);
            let secs = Math.floor((avalue - hours - mins/60) * 3660);
            
            return sign + hours + ":" + `${mins}`.padStart(2, '0') + ":" + `${secs}`.padStart(2, '0');
        },
        formatChoice (value, field) {
            if (!value && value!==0 && value!==false) return '';
    
            if (!field.choices) return value;
    
            let choice = field.choices.find ( h => h.key==value);
    
            if (!choice) return value;
    
            return this.st(choice.value);
        }
    }
}